import React from 'react';
import GameBoard from '../components/GameBoard';
const GameSimulation = () => {
  return <div className="bg-gray-50 py-12" data-id="element-224">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
        <div className="text-center mb-12" data-id="element-226">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-227">
            Simulación del Juego
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-228">
            Experimenta una versión digital del tablero de "Tu Nueva Vida" y
            descubre cómo funciona el juego
          </p>
        </div>
        <GameBoard data-id="element-229" />
        <div className="mt-12 bg-white rounded-xl shadow-sm p-6" data-id="element-230">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-231">
            Cómo usar esta simulación
          </h2>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-232">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-233">
              <h3 className="font-semibold text-gray-900 mb-2" data-id="element-234">
                1. Lanza el dado
              </h3>
              <p className="text-gray-700" data-id="element-235">
                Haz clic en "Lanzar dado" para moverte por el tablero. Tu ficha
                se moverá automáticamente.
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-236">
              <h3 className="font-semibold text-gray-900 mb-2" data-id="element-237">
                2. Toma una carta
              </h3>
              <p className="text-gray-700" data-id="element-238">
                Después de moverte, haz clic en "Tomar carta" para recibir una
                pregunta o reto de la categoría donde has caído.
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-239">
              <h3 className="font-semibold text-gray-900 mb-2" data-id="element-240">
                3. Reflexiona
              </h3>
              <p className="text-gray-700" data-id="element-241">
                Escribe tus pensamientos en el espacio proporcionado. Estas
                reflexiones te ayudarán a crear tu plan de retiro.
              </p>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-242">
            <p className="text-gray-600 mb-4" data-id="element-243">
              Esta es una versión simplificada del juego físico. Para la
              experiencia completa, considera adquirir la versión física.
            </p>
            <a href="#" className="inline-block bg-blue-600 text-white hover:bg-blue-700 px-6 py-3 rounded-lg font-medium" data-id="element-244">
              Comprar el juego físico
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default GameSimulation;